/* global $, prestashop */

$(document).ready(() => {
    console.log('password');
});
